<template>
    <div :id="id" class="tab-content" :class="{'hidden-xs-up': !open}">

        <header class="mobile-header align-items-center p-6 bg-body text-green-light">
            <h2 class="mb-0">{{ title }}</h2>
            <span class="icon-cancel pl-5 ml-auto" @click="closeTab"></span>
        </header>

        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            id: {type: String, required: true},
        },

        data: function () {
            return {
                open: false,
                mobile: false,
                title: '',
            }
        },

        created: function () {
            this.open = false;

            bus.$on( 'tab-content-open', ( id, mobile, slotText ) => {
                if ( this.id === id ) {
                    this.openTab( mobile, slotText );
                } else {
                    this.open = false;
                }
            });
        },

        methods: {
            openRelatedTab: function () {
                bus.$emit( 'tab-content-open', this.for );
            },
            openTab: function ( mobile = false, slotText = '' ) {
                this.open = true;

                if ( mobile ) {
                    this.mobile = mobile;
                    this.title = slotText;
                    $( 'html' ).css( '-webkit-overflow-scrolling', 'touch');
                    $( 'html' ).css( 'overflow', 'hidden');

                    $( 'body' ).css( '-webkit-overflow-scrolling', 'touch');
                    $( 'body' ).css( 'overflow', 'hidden');

                    $( 'body' ).css( 'position', 'fixed');
                    $( 'body' ).css( 'width', '100%');


                }
            },
            closeTab: function () {
                this.open = false;
                $( 'html' ).css( '-webkit-overflow-scrolling', '');
                $( 'html' ).css( 'overflow', '');


                $( 'body' ).css( '-webkit-overflow-scrolling', '');
                $( 'body' ).css( 'overflow', '');

                $( 'body' ).css( 'position', '');
                $( 'body' ).css( 'width', '');


            },
        }
    }
</script>

<style lang="scss">
    @import "./../../sass/variables";

    .tab-content {
        .mobile-header {
            display: none;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/TabContent.vue